// extracted by mini-css-extract-plugin
export var infoRow = "_u8-2";
export var labelContainer = "_u8-0";
export var rightInfo = "_u8-1";